import instanceQuery from 'graphql/queries/schedules/NodeQuery.graphql';
import mutationQuery from 'graphql/mutations/schedules/NodeMutation.graphql';
import addConditionQuery from 'graphql/mutations/schedules/NodeAddConditionMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/schedules/NodeTemporaryMutation.graphql';
import fragment from 'graphql/fragments/schedules/NodeFragment.graphql';
import listQuery from 'graphql/queries/schedules/NodesListQuery.graphql';
import defaultQuery from 'graphql/queries/schedules/NodeDefault.graphql';

const BusinessRuleNode = {
  type: 'Node',
  title: 'Business Rule',
  formTitle: 'Business Rule',
  formUrl: '/BusinessRules/Nodes/',
  workspaceUrl: '/BusinessRules/Workspace/',
  instance: instanceQuery,
  update: mutationQuery,
  temporaryUpdate: temporaryMutationQuery,
  addConditionUpdate: addConditionQuery,
  default: defaultQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'name',
  },
  fragment,
};

export default BusinessRuleNode;
